// extracted by mini-css-extract-plugin
export default {"input":"saa-z","button":"taa-z","selected":"uaa-z","unavailable":"vaa-z","oos":"waa-z","image":"xaa-z","paperCutDisabledOverlay":"yaa-z"};